export const findByLocale = (data: any, locale: string) => {
  const found = data.find((item: any) => item.locale === locale);
  if (!found) {
    throw new Error("Locale not found");
  }
  return found.value;
};
